import React from 'react'
import { isNullOrUndefined } from '../../Simplify360Chat/HWLibrary/HWUtils'
import './ChatLoader.css'
import { s360ConfigService } from '../../Simplify360Chat/Services/S360Config'
export default function ChatLoader() {
  const config = s360ConfigService?.config;
   const loaderStyle=()=>{ 
   
    let styleData = { 
      backgroundColor: isNullOrUndefined(config.designDetails.loaderColor) ? "#941f80" : config.designDetails.loaderColor,
  }
  return styleData;
  }


  return (
    <div className="loader">
        <div className="loader-inner ball-pulse">
          <div style={loaderStyle()}></div>
          <div style={loaderStyle()}></div>
          <div style={loaderStyle()}></div>
        </div>
      </div>
  )

 
}
